/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
import * as __WEBPACK_EXTERNAL_MODULE__agent_infra_logger_ddae3da2__ from "@agent-infra/logger";
import * as __WEBPACK_EXTERNAL_MODULE__config_mjs_e81460ea__ from "./config.mjs";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class BingSearchClient {
    async search(params) {
        this.logger.log('search params', params);
        const { baseUrl, headers } = this.config;
        const queryParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value])=>{
            if (void 0 !== value) queryParams.append(key, value.toString());
        });
        try {
            const response = await fetch(`${baseUrl}?${queryParams}`, {
                method: 'GET',
                headers: {
                    ...headers
                }
            });
            if (!response.ok) throw new Error(`Bing search failed: ${response.status} ${response.statusText}`);
            return await response.json();
        } catch (error) {
            console.error('Error performing Bing search:', error);
            throw error;
        }
    }
    constructor(config){
        _define_property(this, "config", void 0);
        _define_property(this, "logger", void 0);
        this.config = (0, __WEBPACK_EXTERNAL_MODULE__config_mjs_e81460ea__.getBingSearchConfig)(config);
        this.logger = (null == config ? void 0 : config.logger) ?? __WEBPACK_EXTERNAL_MODULE__agent_infra_logger_ddae3da2__.defaultLogger;
        this.logger.log('client config', this.config);
    }
}
const bingSearchClient = new BingSearchClient();
export { BingSearchClient, bingSearchClient };

//# sourceMappingURL=api-client.mjs.map